import queryString from 'query-string';

export const getQueryStringFromObject = (object, options = {}) => queryString.stringify(object, {
  skipNull: true,
  ...options,
});

export const getObjectFromQueryString = (string) => queryString.parse(string, { skipNull: true });
